import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "../../assets/images/task-not-found-1 6.png";
import BtnIcon from "../../assets/icons/add_notes.svg";
import GroupIcon from "../../assets/icons/groups.svg";
// import UserIcon from "../../assets/icons/user.svg";
import UserIcon from "../../assets/icons/person.svg";
import CloseIcon from "../../assets/icons/close.svg";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";
import EmployeeCard from "../../components/EmployeeCard";
import CustomDropdown from "../../commonComponents/CustomDropdown";
import CustomInput from "../../commonComponents/CustomInput";
import CustomFileInput from "../../commonComponents/CustomFileInput";
import CheckIcon from "../../assets/icons/check.svg";
import SubmitIcon from "../../assets/icons/inventory.svg";
import RadioChecked from "../../assets/icons/radio_button_checked.svg";
import RadioUnchecked from "../../assets/icons/radio_button_unchecked.svg";
import AttachmentIcon from "../../assets/icons/attach_email.svg";
import Close from "../../assets/icons/close.svg";
import Sort from "../../assets/icons/sort.svg";
import Request from "../../assets/icons/chat_paste_go_black.svg";
import Active from "../../assets/icons/fast_forward.svg";
import Completed from "../../assets/icons/done_all.svg";
import Block from "../../assets/icons/block.svg";
import ArrownDown from "../../assets/icons/arrow_drop_down.svg";
import ValidIcon from "../../assets/icons/emergency_home.svg";
import SearchIcon from "../../assets/icons/search.svg";
import {
  getDropDownList,
  getuserDetails,
  searchUserDetails,
} from "../../store/PeopleSlice/thunk";
import {
  // attendancePolicy,
  // attendanceShift,
  // attendanceWeeklyOff,
  commonFields,
  workAreaCode,
} from "../../constants/people";
import { useDispatch, useSelector } from "react-redux";
import {
  createChangeRequest,
  generatePresignedURL,
  getAllChangeRequests,
  getAllReportees,
} from "../../store/RequestSlice/thunk";
import "./Requests.css";
import CustomDatePicker from "../../commonComponents/CustomDatePicker";
import { peopleActions } from "../../store/PeopleSlice";
import InitialsCircle from "../../components/InitialsCircle";

const Requests = () => {
  const navigate = useNavigate();
  const LIMIT = 100;
  const REPORTEE_LIMIT = 20;

  const requestTypeOptions = ["Location & Designation Change", "Shift Change"];
  const empColor = ["#DA3D09", "#D0213D", "#0062E2", "#784CD5", "#008A29"];

  const [createRequest, setCreateRequest] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const [filterSelected, setFilterSelected] = useState("");

  const [radioReportee, setRadioReportee] = useState(false);
  const [empSelected, setEmpSelected] = useState(null);
  const [requestType, setRequestType] = useState("");

  const [attendanceShiftType, setAttendanceShiftType] = useState("");
  const [attendancePolicyType, setAttendancePolicyType] = useState("");
  const [weeklyOff, setWeeklyOff] = useState("");
  const [workArea, setWorkArea] = useState("");
  const [requestByEmployee, setRequestByEmployee] = useState("");
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [designation, setDesignation] = useState("");
  const [employmentType, setEmploymentType] = useState("FT");
  const [channelType, setChannelType] = useState("");
  const [manager, setManager] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isDraftSelected, setIsDraftSelected] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");

  const searchTextRef = useRef();
  searchTextRef.current = searchText;
  const searchResultsRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  const [presignedURL, setPresignedURL] = useState("");

  const [requestRemarks, setRequestRemarks] = useState("");
  const [attachments, setAttachments] = useState(null);

  const [summaryView, setSummaryView] = useState(false);
  const [isError, setIsError] = useState(null);

  const [empSearchValue, setEmpSearchValue] = useState("");
  const [empSearchList, setEmpSearchList] = useState([]);

  const observerRef = useRef();
  const firstLoadRef = useRef(true);
  const fileRef = useRef();

  const employeeID = useSelector((state) => state.auth.employeeID);

  const roleType = useSelector(
    (state) => state.auth?.loginResponse?.body?.role_type,
  );

  const getAllReporteesResponse = useSelector(
    (state) => state.request.getAllReporteesResponse,
  );
  const getAllReporteesResponseStatus = useSelector(
    (state) => state.request.getAllReporteesResponseStatus,
  );

  const createChangeRequestResponse = useSelector(
    (state) => state.request.createChangeRequestResponse,
  );
  const createChangeRequestResponseStatus = useSelector(
    (state) => state.request.createChangeRequestResponseStatus,
  );

  const generatePresignedURLResponse = useSelector(
    (state) => state.request.generatePresignedURLResponse,
  );
  const generatePresignedURLResponseStatus = useSelector(
    (state) => state.request.generatePresignedURLResponseStatus,
  );

  const getAllChangeRequestsResponse = useSelector(
    (state) => state.request.getAllChangeRequestsResponse,
  );

  const getAllChangeRequestsResponseStatus = useSelector(
    (state) => state.request.getAllChangeRequestsResponseStatus,
  );

  const getAllLocsResponse = useSelector(
    (state) => state.request.getAllLocsResponse,
  );
  const getAllLocsResponseStatus = useSelector(
    (state) => state.request.getAllLocsResponseStatus,
  );

  const searchList = useSelector((state) => state.people.searchList);
  const searchListStatus = useSelector(
    (state) => state.people.searchListStatus,
  );

  const userDetails =
    useSelector((state) => state.people.userDetails?.user_details) || {};
  const userDetailsStatus = useSelector(
    (state) => state?.people?.userDetailsStatus,
  );

  const fullName = useSelector(
    (state) => state.auth?.loginResponse?.display_name || "",
  );

  const dropDownData =
    useSelector((state) => state?.people?.dropDownListResponse?.data) || {};

  const divRef = useRef(null);
  const [openSearchUpward, setOpenSearchUpward] = useState(false);

  const dispatch = useDispatch();
  // const search = useMemo(() => employeeSearch(allEmployees), [allEmployees]);

  useEffect(() => {
    setInitialStates();
    dispatch(
      getAllReportees({
        offset: 0,
        limit: REPORTEE_LIMIT,
        id_or_name: "",
      }),
    );
    dispatch(
      getAllChangeRequests({
        offset: 0,
        limit: LIMIT,
        request_type: "request",
      }),
    );
    setEmpSearchList(allEmployees);
    dispatch(getDropDownList({}));
  }, []);

  // useEffect(() => {
  //   setEmpSearchList(search(empSearchValue));
  // }, [search, empSearchValue]);

  useEffect(() => {
    if (getAllReporteesResponseStatus !== "SUCCESS") return;

    if (
      getAllReporteesResponseStatus === "SUCCESS" &&
      getAllReporteesResponse?.reportees
    ) {
      if (getAllReporteesResponse?.reportees?.length > 0) {
        if (offset === 0) {
          console.log(
            "\n\n\n\n\nfirst page : ",
            getAllReporteesResponse?.reportees,
          );

          setAllEmployees(getAllReporteesResponse?.reportees);
          firstLoadRef.current = false;
        } else {
          setAllEmployees((prev) => {
            console.log("\n\nELSE: ", prev);

            const ids = new Set(prev.map((e) => e.employee_id));
            const fresh = getAllReporteesResponse?.reportees.filter(
              (e) => !ids.has(e.employee_id),
            );
            console.log("\n\nfresh reportees : ", fresh);
            console.log("\n\nprev reportees : ", [...prev, ...fresh]);
            return [...prev, ...fresh];
          });
        }
        setHasMore(getAllReporteesResponse?.reportees.length >= REPORTEE_LIMIT);
      } else {
        if (offset === 0) {
          setAllEmployees([]);
        }
        setHasMore(false);
      }
    }
  }, [getAllReporteesResponse, getAllReporteesResponseStatus, offset]);

  useEffect(() => {
    if (createChangeRequestResponseStatus === "SUCCESS") {
      console.log(
        "createChangeRequestResponse : ",
        createChangeRequestResponse,
      );
      setIsError(null);
      setCreateRequest(true);
      setEmpSelected(null);
      dispatch(
        getAllReportees({
          offset: 0,
          limit: REPORTEE_LIMIT,
          id_or_name: "",
        }),
      );
      dispatch(
        getAllChangeRequests({
          offset: 0,
          limit: LIMIT,
          request_type: "request",
        }),
      );
    } else if (createChangeRequestResponseStatus === "ERROR") {
      console.log(
        "createChangeRequestResponse : ",
        createChangeRequestResponse,
      );
    }
  }, [createChangeRequestResponseStatus]);

  useEffect(() => {
    if (generatePresignedURLResponseStatus === "SUCCESS") {
      console.log(
        "generatePresignedURLResponse : ",
        generatePresignedURLResponse,
      );
      setPresignedURL(generatePresignedURLResponse?.data?.url);
    } else if (generatePresignedURLResponseStatus === "ERROR") {
    }
  }, [generatePresignedURLResponseStatus]);

  useEffect(() => {
    if (getAllChangeRequestsResponseStatus === "SUCCESS") {
      console.log(
        "getAllChangeRequestsResponse : ",
        getAllChangeRequestsResponse,
      );
      setCreateRequest(true);
      setEmpSelected(null);

      if (getAllChangeRequestsResponse?.data?.length > 0) setSummaryView(true);
    } else if (getAllChangeRequestsResponseStatus === "ERROR") {
      console.log(
        "getAllChangeRequestsResponse : ",
        getAllChangeRequestsResponse,
      );
    }
  }, [getAllChangeRequestsResponseStatus]);

  useEffect(() => {
    // if (allEmployees)
    console.log("reportee list : ", getAllReporteesResponse?.reportees);
    console.log("allEmployees : ", allEmployees);
  }, [allEmployees]);

  const loadMoreEmployees = useCallback(() => {
    if (getAllReporteesResponseStatus === "PENDING" || !hasMore) return;

    const newOffset = offset + REPORTEE_LIMIT;
    setOffset(newOffset);
    dispatch(
      getAllReportees({
        offset: newOffset,
        limit: REPORTEE_LIMIT,
        id_or_name: currentSearchQuery,
      }),
    );
  }, [offset, getAllReporteesResponseStatus, hasMore, currentSearchQuery]);

  const lastEmployeeElementRef = useCallback(
    (node) => {
      if (getAllReporteesResponseStatus === "PENDING") return;

      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            loadMoreEmployees();
          }
        },
        { rootMargin: "0px 0px 300px 0px", threshold: 0.1 },
      );

      if (node) {
        observerRef.current.observe(node);
      }
    },
    [getAllReporteesResponseStatus, hasMore, loadMoreEmployees],
  );

  const setRadioReporteeValue = (value) => {
    setRadioReportee(!radioReportee);
  };

  const submitCreateUserRequest = () => {
    const attachmentKey =
      generatePresignedURLResponse?.presigned_url?.fields?.key || null;

    let payload = {};

    if (requestType === "Location & Designation Change") {
      payload = Object.assign({
        employee_id: empSelected?.employee_id,
        request_type: "Location",
        req_by_emp: requestByEmployee,
        request_remarks: requestRemarks,
        attachments: attachmentKey,
        work_area_code_x: workArea,
        effective_date:
          effectiveDate?.toLocaleDateString("en-CA").slice(0, 10) || null,
        new_manager: manager?.employee_id,
        new_designation: designation,
        new_employment_type: employmentType,
        new_channel: channelType,
      });
    } else if (requestType === "Shift Change") {
      payload = Object.assign({
        employee_id: empSelected?.employee_id,
        request_type: requestType,
        req_by_emp: requestByEmployee,
        request_remarks: requestRemarks,
        attachments: attachmentKey,
        attendance_shift: attendanceShiftType,
        attendance_weeklyoff: weeklyOff,
        effective_date:
          effectiveDate?.toLocaleDateString("en-CA").slice(0, 10) || null,
      });
      if (roleType === "HR") {
        payload.attendance_policy = attendancePolicyType;
      }
    }

    console.log("payload : ", payload);
    const result = isPayloadValid(payload);

    console.log("isPayloadValid : ", result);
    setIsError(!result);

    if (!result) {
      return;
    } else {
      console.log("Payload is valid, submitting request...");
      dispatch(createChangeRequest(payload));
    }
    return;
  };

  const isPayloadValid = (payload) => {
    let notRequiredFields = [];

    if (requestType === "Shift Change")
      notRequiredFields = ["request_remarks", "attachments"];
    else notRequiredFields = ["request_remarks"];

    for (const key in payload) {
      if (notRequiredFields.includes(key)) {
        continue; // Skip validation for non-required fields
      }

      const value = payload[key];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        return false;
      }
    }
    return true;
  };

  const handleFileChange = (e) => {
    console.log("event ", e.target.files[0]);

    const file = e.target.files[0];

    if (file) {
      console.log("file : ", file);
      setAttachments(file);

      let payload = {
        employee_id: employeeID,
        file_name: file?.name,
        key: "attach_doc",
      };
      dispatch(generatePresignedURL({ payload: payload, file: file }));
    } else {
      setAttachments(null);
      fileRef.current.value = "";
      console.log("error in file");
    }
  };

  const clearFile = (e) => {
    e.stopPropagation();

    if (attachments) {
      setAttachments(null);
      fileRef.current.value = "";
      return;
    }
  };

  const setInitialStates = () => {
    setCreateRequest(false);
    setAllEmployees([]);
    setOffset(0);
    setEmpSelected(null);
    setRequestType("");
    setAttachments(null);
    setAttendanceShiftType("");
    setAttendancePolicyType("");
    setWeeklyOff("");
    setWorkArea("");
    setRequestByEmployee("");
    setRequestRemarks("");
    setEffectiveDate(null);
    setSummaryView(false);
    setIsError(null);
  };

  const closeEmp = () => {
    setRequestType(null);
    setEmpSelected(null);
    setRequestByEmployee("");
    setRequestRemarks("");
    setAttendanceShiftType("");
    setAttendancePolicyType("");
    setWeeklyOff("");
    setWorkArea("");
    setEffectiveDate(null);
    setIsError(null);
    setAttachments(null);
    setRequestRemarks("");
  };

  const setSelectedEmployeeData = (item) => {
    setEmpSelected(item);
    setAttendanceShiftType(item.attendance_shift);
    setAttendancePolicyType(item.attendance_policy);
    setWeeklyOff(item.attendance_weeklyoff);
    setRequestByEmployee("");
    setEffectiveDate(null);
  };

  const backButtonHandler = () => {
    // setInitialStates()
    setCurrentSearchQuery("");
    if (!createRequest && !empSelected) {
      console.log("IF");

      console.log("createRequest", createRequest);
      console.log("empSelected", empSelected);
      setCreateRequest(true);
      dispatch(
        getAllReportees({
          offset: 0,
          limit: REPORTEE_LIMIT,
          id_or_name: "",
        }),
      );
      dispatch(
        getAllChangeRequests({
          offset: 0,
          limit: LIMIT,
          request_type: "request",
        }),
      );
    } else if (!createRequest && empSelected) {
      console.log("ELSE IF");
      setIsError(null);
      setEmpSelected(null);
      setRequestType("");

      console.log("createRequest", createRequest);
      console.log("empSelected", empSelected);

      setEmpSelected(null);
      dispatch(
        getAllReportees({
          offset: 0,
          limit: REPORTEE_LIMIT,
          id_or_name: "",
        }),
      );
    } else {
      console.log("ELSE");
      setCreateRequest(true);
      setEmpSelected(null);
      dispatch(
        getAllReportees({
          offset: 0,
          limit: REPORTEE_LIMIT,
          id_or_name: "",
        }),
      );
      dispatch(
        getAllChangeRequests({
          offset: 0,
          limit: LIMIT,
          request_type: "request",
        }),
      );
    }
  };

  const LocationSummaryRowCard = ({ item, index }) => {
    return (
      <div className="summary-container" index={index}>
        <div className="summary-header">
          <div className="summary-emp-id">Employee ID #{item.employee_id}</div>

          <div className="emp-logo-box">
            {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
            <InitialsCircle fullName={item?.full_name} size={24} />
            <div className="summary-emp-name">{item.full_name}</div>

            <div className="spacer-dot">•</div>

            <div className="summary-loc">Location & Designation Change</div>
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details w-40">
            <div className="row-item-heading">Proposed Location / Store</div>
            <div className="row-item-value">
              {item.new_location +
                " - " +
                JSON.parse(item?.new_value)?.work_area_code_x}
            </div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Initiated By</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Trigger Date</div>
            <div className="row-item-value">{item.effective_date}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Approval Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Rejected" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const AttendanceSummaryRowCard = ({ item, index }) => {
    return (
      <div className="summary-container" index={index}>
        <div className="summary-header">
          <div className="summary-emp-id">Employee ID #{item.employee_id}</div>

          <div className="emp-logo-box">
            {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
            <InitialsCircle fullName={item?.full_name} size={24} />
            <div className="summary-emp-name">{item.full_name}</div>

            <div className="spacer-dot">•</div>

            <div className="summary-loc">Attendance Shift Change</div>
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details w-40">
            <div className="row-item-heading">Proposed Attendance Shift</div>
            <div className="row-item-value">
              {JSON.parse(item?.new_value)?.attendance_shift}
            </div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Proposed Weekly Off</div>
            <div className="row-item-value">
              {" "}
              {JSON.parse(item?.new_value)?.attendance_weeklyoff}
            </div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Initiated By</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Trigger Date</div>
            <div className="row-item-value">{item.effective_date}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Approval Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Rejected" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const DesignationSummaryRowCard = ({ item, index }) => {
    return (
      <div className="summary-container" index={index}>
        <div className="summary-header">
          <div className="summary-emp-id">Employee ID #{item.employee_id}</div>

          <div className="emp-logo-box">
            {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
            <InitialsCircle fullName={item?.full_name} size={24} />
            <div className="summary-emp-name">{item.full_name}</div>

            <div className="spacer-dot">•</div>

            <div className="summary-loc">Designation Change</div>
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details w-40">
            <div className="row-item-heading">Proposed Designation</div>
            <div className="row-item-value">{item.new_location}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Initiated By</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Trigger Date</div>
            <div className="row-item-value">{item.effective_date}/</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Approval Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Rejected" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const onSearchUser = (searchText) => {
    if (!searchText.trim()) {
      setShowSearchResults(false);
      return;
    }

    dispatch(
      searchUserDetails({
        id_or_name: searchTextRef.current,
        draft: isDraftSelected,
      }),
    ).then(() => {
      setShowSearchResults(true);
    });
  };

  const handleSearchChange = (e) => {
    let inputValue = "";

    if (typeof e === "string") inputValue = e;
    else inputValue = e.target.value;

    setSearchText(inputValue);

    if (inputValue.length < 3) {
      setShowSearchResults(false);
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      return;
    }
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      onSearchUser(inputValue);
    }, 500);
  };

  const checkPositionAndSetDirection = () => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      setOpenSearchUpward(rect.top > windowHeight / 2);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmpSearchValue(value);
  };
  const handleSearchKeyDown = (e) => {
    if (e.key !== "Enter") return;

    const value = e.target.value.trim();
    if (!value) return;

    setOffset(0);
    setHasMore(true);
    setAllEmployees([]);
    setCurrentSearchQuery(value);
    dispatch(
      getAllReportees({
        offset: 0,
        limit: REPORTEE_LIMIT,
        id_or_name: value,
      }),
    );
  };

  return (
    <div className="rq-home">
      {createRequest ? (
        <>
          {summaryView ? (
            <>
              <div className="header">
                <div className="head-left-container">
                  <button
                    type="button"
                    aria-label="Back to all modules"
                    className="xl:hidden mr-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
                    onClick={() => navigate("../all")}
                  >
                    <img src={ArrowbackIcon} alt="Back" className="h-5 w-5" />
                  </button>
                  <div className="rq-head !px-0 font-semibold">requests</div>
                </div>
                <button
                  className="btn rq-home-btn"
                  onClick={() => {
                    setIsError(null);
                    setCreateRequest(false);
                  }}
                >
                  <img src={BtnIcon} alt="" className="rq-home-btn-ico" />
                  <div className="rq-home-btn-text">Initiate Request</div>
                </button>
              </div>
              <div className="flex rq-create-summary">
                <div className="rq-summary-container">
                  {getAllChangeRequestsResponse?.data?.length > 0 ? (
                    getAllChangeRequestsResponse?.data?.map((item, index) => {
                      if (item.request_type === "Location") {
                        return (
                          <LocationSummaryRowCard key={index} item={item} />
                        );
                      } else if (item.request_type === "Shift Change") {
                        return (
                          <AttendanceSummaryRowCard key={index} item={item} />
                        );
                      } else if (item.request_type === "Designation Change") {
                        return (
                          <DesignationSummaryRowCard key={index} item={item} />
                        );
                      }
                    })
                  ) : (
                    <div className="rq-summary-empty">No requests found</div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="header">
                <div className="head-left-container">
                  <button
                    type="button"
                    aria-label="Back to all modules"
                    className="xl:hidden mr-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
                    onClick={() => navigate("../all")}
                  >
                    <img src={ArrowbackIcon} alt="Back" className="h-5 w-5" />
                  </button>
                  <div className="rq-head !px-0 font-semibold">requests</div>
                </div>
              </div>
              <div className="flex justify-center items-center rq-create">
                <img className="rq-home-ico" src={HomeIcon} alt="" />
                <div className="rq-home-text">
                  Looks like you have not requested any flow yet!
                </div>
                <button
                  className="btn rq-home-btn"
                  onClick={() => setCreateRequest(false)}
                >
                  <img src={BtnIcon} alt="" className="rq-home-btn-ico" />
                  <div className="rq-home-btn-text">Initiate Request</div>
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <div
          className="rq-form"
          onClick={() => {
            if (showSearchResults === true) setShowSearchResults(false);
          }}
        >
          <div className="header">
            <div className="head-left-container">
              <img
                className="arrow-icon"
                src={ArrowbackIcon}
                alt="arrow-back"
                onClick={backButtonHandler}
              />

              <div className="rq-head">initiate request</div>
            </div>

            <div className="head-right-container ml-auto">
              {requestType && (
                <button
                  className="btn p-btn p-btn-og ml-auto"
                  onClick={submitCreateUserRequest}
                >
                  <img className="p-btn-icon" src={SubmitIcon} alt="" />
                  <div className="p-btn-text">Submit</div>
                </button>
              )}
            </div>
          </div>
          {empSelected ? (
            <div className="rq-init-form">
              <div className="rq-top-container">
                <div className="rq-form-head">
                  <div className="rq-form-head-text">
                    Initiate the request process for
                  </div>
                  <div className="rq-emp-selected">
                    <div className="flex flex-col">
                      <div className="rq-emp-id">
                        #{empSelected?.employee_id}
                      </div>
                      <div className="flex items-center">
                        <div className="flex items-center">
                          <InitialsCircle
                            fullName={empSelected?.full_name}
                            size={24}
                          />
                          <div className="rq-emp-name">
                            {empSelected?.full_name}
                          </div>
                        </div>
                        <div
                          className="flex rq-grp-com"
                          style={{
                            backgroundColor:
                              empColor[Math.floor(Math.random() * 5)],
                          }}
                        >
                          <img
                            className="rq-grp-icon"
                            src={GroupIcon}
                            alt="emp-icon"
                          />
                          <div className="rq-grp-text">
                            {empSelected?.business_unit}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="rq-close-wrap">
                      <img
                        className="rq-emp-close"
                        src={CloseIcon}
                        alt=""
                        onClick={closeEmp}
                      />
                    </div>
                  </div>
                </div>
                <div className="rq-type">
                  <div className="flex">
                    <CustomDropdown
                      showOptional={true}
                      label={"Request type*"}
                      isError={isError}
                      className="emp-form-input mb-0"
                      options={requestTypeOptions}
                      value={requestType}
                      onSelectOption={(value) => setRequestType(value)}
                      isRequired={false}
                    />
                  </div>
                  {requestType === "Location & Designation Change" && (
                    <div className="rq-loc-form">
                      <div className="rq-loc-head">
                        location and designation change without promotion
                      </div>
                      <div className="pr-pf-detail-table-details">
                        <div className="pf-tab-wrap">
                          <div className="pr-pf-details-box">
                            <div className="pr-pf-detail-label">
                              Current Store
                            </div>
                            <div className="pr-pf-detail-value-field">
                              {empSelected?.loc_name}
                            </div>
                          </div>
                          <div className="pr-pf-details-box">
                            <div className="pr-pf-detail-label">
                              Current Designation
                            </div>
                            <div className="pr-pf-detail-value-field">
                              {empSelected?.business_unit}
                            </div>
                          </div>
                          <div className="pr-pf-details-box">
                            <div className="pr-pf-detail-label">
                              Current Manager
                            </div>
                            <div className="pr-pf-detail-value-field">
                              {empSelected?.direct_manager_name}
                            </div>
                          </div>
                          <div className="pr-pf-details-box">
                            <div className="pr-pf-detail-label">
                              Current Employment Type
                            </div>
                            <div className="pr-pf-detail-value-field">
                              {empSelected?.employment_type}
                            </div>
                          </div>
                          <div className="pr-pf-details-box">
                            <div className="pr-pf-detail-label">
                              Current Channel
                            </div>
                            <div className="pr-pf-detail-value-field">
                              {empSelected?.channel}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col work-check-common mt-12">
                        <div className="work-label">
                          Whether the transfer is requested by the employee?
                        </div>
                        <div className="flex pb-12">
                          <div
                            className={`flex items-center work-check-box`}
                            onClick={() => setRequestByEmployee("Yes")}
                            style={{
                              borderColor:
                                requestByEmployee === "Yes"
                                  ? "#172128"
                                  : "transparent",
                              borderWidth: 2,
                              borderStyle: "solid",
                              backgroundColor: "#F1F6FA",
                            }}
                          >
                            <img
                              className="work-icon"
                              src={CheckIcon}
                              alt="work-icon"
                            />
                            <div className="work-check-label">Yes</div>
                          </div>
                          <div
                            className={`flex items-center work-check-box`}
                            onClick={() => setRequestByEmployee("No")}
                            style={{
                              borderColor:
                                requestByEmployee === "No"
                                  ? "#172128"
                                  : "transparent",
                              borderWidth: 2,
                              borderStyle: "solid",
                              backgroundColor: "#F1F6FA",
                            }}
                          >
                            <img
                              className="work-icon"
                              src={CloseIcon}
                              alt="work-icon"
                            />
                            <div className="work-check-label">No</div>
                          </div>
                        </div>

                        {isError && requestByEmployee === "" && (
                          <div className="valid-text flex items-center">
                            <img
                              src={ValidIcon}
                              alt=""
                              style={{ marginRight: "4px" }}
                            />
                            <div>Please select an option</div>
                          </div>
                        )}
                      </div>
                      <div className="grid-container">
                        <CustomDropdown
                          showOptional={true}
                          label={"Proposed Store / Location"}
                          placeholder="Select Proposed Store / Location"
                          isError={isError}
                          className="emp-form-input"
                          options={dropDownData?.location_fin || []}
                          value={workArea}
                          onSelectOption={(value) => {
                            setWorkArea(value);
                          }}
                          isRequired={true}
                        />

                        <CustomDatePicker
                          isRequired={true}
                          // showOptional={showOptional}
                          isError={isError}
                          label={"Effective Start Date"}
                          onChange={(value) => setEffectiveDate(value)}
                          value={effectiveDate}
                          placeholderText={"Select Date"}
                          allowFutureDate={true}
                          allowPastDate={false}
                        />

                        <div style={{ marginRight: "none" }}>
                          <CustomDropdown
                            showOptional={true}
                            label={"Proposed Designation"}
                            placeholder="Select Proposed Designation"
                            isError={isError}
                            className="emp-form-input"
                            options={dropDownData?.designationNameAndCode || []}
                            value={designation}
                            onSelectOption={(value) => {
                              setDesignation(value);
                            }}
                            isRequired={true}
                          />
                        </div>

                        <div className="manager-search-container" ref={divRef}>
                          <CustomInput
                            isError={isError}
                            label={"Proposed Manager"}
                            editable={true}
                            value={
                              searchClicked
                                ? manager?.full_name +
                                  " - " +
                                  manager.employee_id
                                : searchText
                            }
                            placeholder="Select a Proposed Manager"
                            onChange={(value) => handleSearchChange(value)}
                            isRequired={true}
                            onSelect={() => {
                              setSearchClicked(false);
                              if (searchText.length > 3) {
                                checkPositionAndSetDirection();
                                setShowSearchResults(true);
                              }
                            }}
                            validationStr={
                              /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/
                            }
                          />

                          {showSearchResults && (
                            <div
                              className={`search-results-dropdown ${
                                openSearchUpward ? "open-upward" : ""
                              }`}
                              ref={searchResultsRef}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {searchListStatus === "PENDING" ? (
                                <div className="search-no-results">
                                  Searching...
                                </div>
                              ) : searchList?.user_details &&
                                searchList.user_details.length > 0 ? (
                                searchList.user_details.map((item) => (
                                  <div
                                    key={item.employee_id}
                                    className={`search-result-item ${
                                      userDetails.employee_id?.value ===
                                      item.employee_id
                                        ? "selected"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSearchClicked(true);
                                      setShowSearchResults(false);
                                      // getSelectedUserDetails(item.employee_id);
                                      setManager(item);
                                    }}
                                  >
                                    <div className="search-result-details">
                                      {/* <img
                                              className="search-emp-icon"
                                              src={UserIcon}
                                              alt="emp-icon"
                                            /> */}
                                      <InitialsCircle
                                        fullName={
                                          item?.full_name || item?.first_name
                                        }
                                        size={24}
                                      />
                                      <span className="search-result-name">
                                        {item?.full_name || item?.first_name}
                                      </span>
                                      <span className="dot"> • </span>
                                      <span className="search-result-id">
                                        {item.designation}
                                      </span>
                                      <span className="dot"> • </span>
                                      <span className="search-result-id">
                                        Employee ID #{item.employee_id}
                                      </span>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="search-no-results">
                                  No employees found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <CustomDropdown
                          showOptional={true}
                          label={"Proposed Employment type"}
                          placeholder="Select Proposed Employment type"
                          isError={isError}
                          className="emp-form-input"
                          options={["FT", "PT"]}
                          value={employmentType}
                          onSelectOption={(value) => {
                            setEmploymentType(value);
                          }}
                          isRequired={true}
                        />
                        <CustomDropdown
                          showOptional={true}
                          label={"Proposed Channel"}
                          placeholder="Select Channel"
                          isError={isError}
                          className="emp-form-input"
                          options={["Amazon", "Amazon Express", "More", "Omni"]}
                          value={channelType}
                          onSelectOption={(value) => {
                            setChannelType(value);
                          }}
                          isRequired={true}
                        />
                      </div>
                    </div>
                  )}
                  {requestType === "Shift Change" && (
                    <div className="rq-shift-form">
                      <div className="flex flex-wrap">
                        <CustomDropdown
                          showOptional={true}
                          label={"Shift Type*"}
                          isError={isError}
                          className="emp-form-input"
                          options={dropDownData?.attendanceShift || []}
                          value={attendanceShiftType}
                          onSelectOption={(value) =>
                            setAttendanceShiftType(value)
                          }
                          isRequired={false}
                        />
                        {roleType === "HR" && (
                          <CustomDropdown
                            showOptional={true}
                            label={"Attendance Policy Type"}
                            isError={isError}
                            className="emp-form-input"
                            options={dropDownData?.attendancePolicy || []}
                            value={attendancePolicyType}
                            onSelectOption={(value) =>
                              setAttendancePolicyType(value)
                            }
                            isRequired={true}
                          />
                        )}
                        <CustomDropdown
                          showOptional={true}
                          label={"Weekly Off"}
                          isError={isError}
                          className="emp-form-input"
                          options={dropDownData?.attendanceWeeklyOff || []}
                          value={weeklyOff}
                          onSelectOption={(value) => setWeeklyOff(value)}
                          isRequired={true}
                        />
                      </div>
                      <div className="flex flex-wrap">
                        <CustomDatePicker
                          isRequired={true}
                          // showOptional={showOptional}
                          isError={isError}
                          label={"Effective Start Date"}
                          onChange={(value) => {
                            console.log(
                              "\n\n\n\n\nEffective Start Date:",
                              value,
                            );
                            setEffectiveDate(value);
                          }}
                          value={effectiveDate}
                          placeholderText={"Select Date"}
                          allowFutureDate={true}
                          allowPastDate={false}
                        />
                      </div>

                      <div className="flex flex-col work-check-common mt-12">
                        <div className="work-label">
                          Whether the transfer is requested by the employee?
                        </div>
                        <div className="flex pb-12">
                          <div
                            className={`flex items-center work-check-box`}
                            onClick={() => setRequestByEmployee("Yes")}
                            style={{
                              borderColor:
                                requestByEmployee === "Yes"
                                  ? "#172128"
                                  : "transparent",
                              borderWidth: 2,
                              borderStyle: "solid",
                              backgroundColor: "#F1F6FA",
                            }}
                          >
                            <img
                              className="work-icon"
                              src={CheckIcon}
                              alt="work-icon"
                            />
                            <div className="work-check-label">Yes</div>
                          </div>
                          <div
                            className={`flex items-center work-check-box`}
                            onClick={() => setRequestByEmployee("No")}
                            style={{
                              borderColor:
                                requestByEmployee === "No"
                                  ? "#172128"
                                  : "transparent",
                              borderWidth: 2,
                              borderStyle: "solid",
                              backgroundColor: "#F1F6FA",
                            }}
                          >
                            <img
                              className="work-icon"
                              src={CloseIcon}
                              alt="work-icon"
                            />
                            <div className="work-check-label">No</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>{" "}
              {empSelected && (
                <div className="remarks-outer">
                  {isError && !attachments && (
                    <div className="valid-text error-bubble">
                      <img
                        src={ValidIcon}
                        alt=""
                        style={{ marginRight: "4px" }}
                      />
                      <div>Attach a supporting document</div>
                    </div>
                  )}

                  {requestType && (
                    <div className="remarks-container">
                      {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
                      <InitialsCircle
                        fullName={fullName}
                        size={30}
                        type="profile"
                      />
                      <input
                        id="request-attachment-box"
                        type="text"
                        className={"request-attachment-box"}
                        onChange={(e) => setRequestRemarks(e.target.value)}
                        placeholder="Mention a comment along with your request"
                        value={requestRemarks}
                      />

                      <div
                        className="attachment-button"
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                      >
                        {attachments && (
                          <div className="file-attachment" onClick={clearFile}>
                            <img src={Close} alt="" />
                          </div>
                        )}
                        <img src={AttachmentIcon} alt="" />
                        <input
                          id="fileInput"
                          style={{
                            display: "none",
                            opacity: 0,
                            height: "0px",
                            width: "0px",
                          }}
                          type="file"
                          onChange={handleFileChange}
                          ref={fileRef}
                        />

                        <div className="attachment-button-text">
                          {attachments?.name || "Attach Document"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="rq-emp-list">
              <div className="rq-emp-head">
                <div className="req-search-container">
                  <div>
                    Select a reportee to initiate requests on their behalf.
                  </div>
                  <div className="req-search-box">
                    <img
                      // className="work-icon"
                      src={SearchIcon}
                      alt="search-icon"
                    />

                    <input
                      className="rq-search-input"
                      placeholder="Search by employee name or id"
                      onChange={handleChange}
                      onKeyDown={handleSearchKeyDown}
                      value={empSearchValue}
                    />
                    {/* <div className="req-search-text">
                          Search by employee name or id
                        </div> */}
                    {empSearchValue && (
                      <img
                        className="serach-close"
                        src={CloseIcon}
                        alt="close-icon"
                        onClick={() => {
                          setEmpSearchValue("");
                          setCurrentSearchQuery("");
                          setAllEmployees([]);
                          setOffset(0);
                          setHasMore(true);
                          dispatch(
                            getAllReportees({
                              offset: 0,
                              limit: REPORTEE_LIMIT,
                              id_or_name: "",
                            }),
                          );
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="card-container">
                {allEmployees?.length > 0 && (
                  <div className="rq-cards">
                    {allEmployees?.map((item, index) => {
                      const isLastElement = allEmployees.length === index + 1;

                      return (
                        <div
                          key={`${item.employee_id}-${index}`}
                          ref={isLastElement ? lastEmployeeElementRef : null}
                        >
                          <EmployeeCard
                            page={"request"}
                            isExpanded={false}
                            data={item}
                            onSelectEmployee={() => {
                              setSelectedEmployeeData(item);
                              setEmpSearchValue("");
                            }}
                            userDetails={empSelected}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {getAllReporteesResponseStatus === "SUCCESS" &&
                allEmployees?.length === 0 && (
                  <div className="w-full">No reportees found</div>
                )}

              {/* {!hasMore && allEmployees.length > 0 && (
                <div className="end-of-results">No more reportees to load</div>
              )} */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default Requests;

const employeeSearch = (employees) => {
  if (!employees?.length) return () => [];
  const idMap = new Map(employees.map((e) => [e.employee_id, e]));
  return (q = "") => {
    const s = q.trim();
    if (!s) return employees; // initial full list
    if (/^\d+$/.test(s)) {
      const hit = idMap.get(s);
      if (hit) return [hit]; // exact ID
    }
    const term = s.toLowerCase();
    return employees.filter(
      (e) =>
        e.employee_id.includes(term) ||
        e.full_name.toLowerCase().includes(term),
    );
  };
};
